import script from "./LeftLauncherIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftLauncherIcon.vue?vue&type=script&lang=ts&setup=true"

import "./LeftLauncherIcon.vue?vue&type=style&index=0&id=76d8842b&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d8842b"]])

export default __exports__